import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppletContainerModel } from '../../../../../models/aggregates/applet/applet-container.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination } from '../shared';

@Injectable({ providedIn: 'root' })
export class AppletService extends BaseApiTemplateService<AppletContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      'applets';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets';
    this.httpClient = http;
  }

  addImageFile(appletGuid: string, file: File, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + appletGuid + '?appletSystemType=SYS_APPLET_IMAGES';
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/add-files/' + appletGuid + '?appletSystemType=SYS_APPLET_IMAGES';
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('files', file);
    }

    return this.httpClient.put(url, formData, this.getHttpHeader(apiVisa))
  }

  addVideoFile(appletGuid: string, file: File, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + appletGuid + '?appletSystemType=SYS_APPLET_VIDEOS';
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/add-files/' + appletGuid + '?appletSystemType=SYS_APPLET_VIDEOS';
    }
    const formData: FormData = new FormData();
    if (file) {
      formData.append('files', file);
    }

    return this.httpClient.put(url, formData, this.getHttpHeader(apiVisa))
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  updateAppletLogo(apiVisa: ApiVisa, file: File, appletGuid: string) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/icon/' + appletGuid;
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    return this.httpClient.put(apiUrl, formData, this.getHttpHeader(apiVisa));
  }
  /**
  @param iconGuid bl_applet_hdr.applet_icon_file_guid
  */
  getAppletLogo(apiVisa: ApiVisa, iconGuid: string) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/public/file/applet-icon/' + iconGuid;
    return this.httpClient.get(apiUrl, this.getHttpHeader(apiVisa));
  }

  getAppletStoreView(apiVisa: ApiVisa, hdrGuid: string) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/applet-store-view/' + hdrGuid;
    return this.httpClient.get(apiUrl, this.getHttpHeader(apiVisa));
  }

  getAppletsByCriteriaAsSysAdmin(pagination: Pagination, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/sysadmin-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get(apiUrl, this.getHttpHeader(apiVisa));
  }

  createAppletAsSysAdmin(applet: AppletContainerModel, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/sysadmin-ep';
    return this.httpClient.post(apiUrl, applet, this.getHttpHeader(apiVisa));
  }

  updateAppletAsSysAdmin(applet: AppletContainerModel, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/sysadmin-ep';
    return this.httpClient.put(apiUrl, applet, this.getHttpHeader(apiVisa));
  }

  deleteAppletAsSysAdmin(guid: String, apiVisa: ApiVisa) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/sysadmin-ep/inactivation/' + guid;
    return this.httpClient.delete(apiUrl, this.getHttpHeader(apiVisa));
  }

  updateAppletLogoAsAsSysadmin(apiVisa: ApiVisa, file: File, appletGuid: string) {
    const apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applets/sysadmin-ep/icon/' + appletGuid;
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    return this.httpClient.put(apiUrl, formData, this.getHttpHeader(apiVisa));
  }

  private setUrl(endpoint: string, apiVisa: ApiVisa){
    this.apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `applets/${endpoint}`;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + `applets/${endpoint}`
  }

  getByGuidAsSysadmin(guid: string, apiVisa: ApiVisa){
    this.setUrl('sysadmin-ep', apiVisa);
    return super.getByGuid(guid, apiVisa);
  }

  getFileAsSysadmin(extGuid: string, apiVisa: ApiVisa): Observable<Blob> {
    this.setUrl('sysadmin-ep', apiVisa);
    return this.getFile(extGuid, apiVisa);
  }

}
